import React, { useState } from 'react';
import styles from '../../../styles/hardware-partners/hardwarePartner.module.css';
import { AdvanceAnalyticsBanner, BlackCustomButton, HardwareFeatures, HardwareTab, MarqueeComponentHomePage, Tabs, TransparentCustomButton, WhiteCustomButton } from '@/components/qbStrap';
import Image from 'next/image';
import OutletFeatures from '@/components/common/OutletFeatures';
import { ClientsArr1, testimonialData, zomatoFeatures, videoTestimonial, zomatoFAQ, swiggyFAQ, swiggyFeatures , getTitleContent } from '@/constants/common';
import ThreeStepForm from '@/components/common/ThreeStepForm';
import TestimonialSection from '@/components/common/TestimonialSection';
import TrustFactor from '@/components/common/TrustFactor';
import FrequentQuestions from '@/components/homePage/FrequentQuestions';
import PersonalisedDemoBanner from '@/components/common/PersonalisedDemoBanner';
import VerificationPopup from '@/components/modals/VerificationPopup';
import { useRouter } from 'next/router';
import content from '../../../language/ENGLISH.json';

const DesktopGSP = () => {

    const [demoModal, setDemoModal] = useState(false);
    const [formHeading, setHeading] = useState("Book your free demo now!");
    const router = useRouter();

    const { commonMarqueTitle } = getTitleContent();

    const gspFeatures = [
        {
            id: 1,
            image: "/assets/software-partners/gsp/gst-calculation.webp",
            title: "Accurate GST Payable Calculation",
            desc: "QueueBuster ensures accurate GST payable calculation by automating the entire process. Our system meticulously calculates the GST payable for each transaction, taking into account all applicable tax rates and exemptions. This eliminates the risk of errors and ensures that your business always complies with GST regulations.",
            bgColor: "#8ae4f626",
            imageHeight: "42rem",
            mobImageHeight: "20rem",
            btnText: "Speak with an expert",
            imageWidth: "40rem",
            tagColor: "#C9F6FF",
            points: [
                "Automates GST calculation for each transaction.",
                "Ensures compliance with applicable tax rates and exemptions.",
                "Minimizes the risk of manual errors in tax calculation.",
            ]
        },
        {
            id: 2,
            image: "/assets/software-partners/gsp/structured-trading-commodities.svg",
            title: "Structured Trading of Commodities",
            desc: "QueueBuster’s integration supports structured trading of commodities, ensuring that all transactions are recorded accurately and systematically. This structure helps maintain clear records and facilitates easy retrieval of transaction data when required, making it easier to comply with GST regulations.",
            bgColor: "#F2FDEB",
            imageHeight: "32rem",
            mobImageHeight: "16rem",
            btnText: "Request a callback",
            tagColor: "#d4f4bf",
            points: [
                "Maintains accurate and systematic records of all transactions.",
                "Facilitates easy retrieval of transaction data for compliance purposes.",
                "Supports structured trading to ensure clear and compliant records."
            ]
        },
        {
            id: 3,
            image: "/assets/software-partners/gsp/multiple-returns-gstn.svg",
            title: "Generate Multiple Returns with GSTN",
            desc: "QueueBuster simplifies the process of generating multiple returns that need to be filed with the GST Network (GSTN). Our system allows you to generate these returns quickly and accurately, ensuring that all necessary information is included and compliant with GST requirements.",
            bgColor: "#FCF7FF",
            imageHeight: "44rem",
            mobImageHeight: "22rem",
            btnText: "Talk to an expert",
            tagColor: "#e6ccf6",
            points: [
                "Simplifies the generation of multiple GST returns.",
                "Ensures that all necessary information is included and compliant.",
                "Facilitates quick and accurate return generation for GST filing."
            ]
        },
        {
            id: 4,
            image: "/assets/software-partners/gsp/GSP.svg",
            title: " Integration with GST Suvidha Provider (GSP)",
            desc: "QueueBuster integrates seamlessly with GST Suvidha Provider (GSP), enabling easy submission of GST reports. This integration ensures that your GST reports are submitted accurately and on time, reducing the administrative burden on your business and ensuring compliance with GST regulations.",
            bgColor: "#8ae4f626",
            imageHeight: "42rem",
            mobImageHeight: "20rem",
            btnText: "Speak with an expert",
            tagColor: "#C9F6FF",
            points: [
                "Seamless integration with GST Suvidha Providers for report submission.",
                "Ensures accurate and timely submission of GST reports.",
                "Reduces the administrative burden on your business."
            ]
        },
        {
            id: 5,
            image: "/assets/software-partners/gsp/reduction-manual-error.svg",
            title: "Reduction of Manual Errors",
            desc: "By automating tax calculations, QueueBuster significantly reduces the risk of manual errors. Our system ensures that all tax calculations are performed accurately, taking into account the latest GST rates and rules. This automation not only improves accuracy but also saves time and resources.",
            bgColor: "#F2FDEB",
            imageHeight: "32rem",
            mobImageHeight: "16rem",
            btnText: "Request a callback",
            tagColor: "#d4f4bf",
            points: [
                "Automates tax calculation to reduce manual errors.",
                "Ensures accurate calculations based on the latest GST rates and rules.",
                "Saves time and resources by eliminating manual processes."

            ]
        },
        {
            id: 6,
            image: "/assets/software-partners/gsp/gst-rates.svg",
            title: "Facility of ePayment as per Applicable GST Rates",
            desc: "QueueBuster provides a facility for payment of GST as per applicable rates. This feature ensures that your GST payments are made accurately and on time, avoiding any penalties or compliance issues. The payment facility simplifies the payment process and ensures that your business complies with GST regulations.",
            bgColor: "#FCF7FF",
            imageHeight: "44rem",
            mobImageHeight: "22rem",
            tagColor: "#e6ccf6",
            btnText: "Talk to an expert",
            points: [
                "Facilitates accurate and timely e-payment of GST.",
                "Ensures compliance with applicable GST rates.",
                "Simplifies the GST payment process to avoid penalties."
            ]
        },
        {
            id: 7,
            image: "/assets/software-partners/gsp/GST-amounts.svg",
            title: "Precise Reports for ITC and GST Amounts",
            desc: "QueueBuster generates precise reports for Input Tax Credit (ITC) and GST amounts, providing you with clear and accurate information for tax filing and compliance. These reports help in tracking ITC claims and GST liabilities, ensuring that your business remains compliant and can optimize tax benefits.",
            bgColor: "#8ae4f626",
            imageHeight: "42rem",
            mobImageHeight: "20rem",
            btnText: "Speak with an expert",
            tagColor: "#C9F6FF",
            points: [
                "Generates precise reports for ITC and GST amounts.",
                "Provides clear and accurate information for tax filing and compliance.",
                "Helps track ITC claims and GST liabilities for optimized tax benefits."

            ]
        },
        {
            id: 8,
            image: "/assets/software-partners/gsp/receipts.svg",
            title: "GST compliant Invoices and Receipts",
            desc: "QueueBuster ensures that all invoices and receipts generated by your business are GST-compliant. Our system automatically includes all necessary details and formats invoices and receipts as per GST regulations. This compliance helps in avoiding any issues during audits and ensures smooth operations.",
            bgColor: "#F2FDEB",
            imageHeight: "32rem",
            mobImageHeight: "16rem",
            btnText: "Request a callback",
            tagColor: "#d4f4bf",
            points: [
                "Generates GST-compliant invoices and receipts automatically.",
                "Ensures inclusion of all necessary details as per GST regulations.",
                "Helps avoid issues during audits and ensures smooth operations."
            ]
        },
    ];

    const GSPFAQ = [
        {
            para: (
                <span style={{ width: "90%" }}>
                    How does QueueBuster ensure accurate GST payable calculation?
                </span>
            ),
            des: "QueueBuster GST billing software ensures accurate GST payable calculation by automating the entire process, which eliminates the risk of manual errors. Once you set GST rates as per the slab while creating your catalog, this software calculates the GST payable for each transaction, considering all applicable tax rates and exemptions.",
            id: 1,
            activeIndex: 1,
        },
        // {
        //     para: (
        //         <span style={{ width: "90%" }}>
        //             How does QueueBuster support the structured trading of commodities?
        //         </span>
        //     ),
        //     des: "QueueBuster supports the structured trading of commodities by maintaining accurate and systematic records of all transactions. The system facilitates the easy retrieval of transaction data, which is crucial for GST compliance. This structured approach ensures that all transactions are recorded properly, making it easier to manage and review them for GST filing purposes, thereby enhancing transparency and compliance.",
        //     id: 2,
        //     activeIndex: 0,
        // },
        {
            para: (
                <span style={{ width: "90%" }}>
                    How can I generate multiple GST returns using QueueBuster?
                </span>
            ),
            des: "QueueBuster simplifies the process of generating multiple GST returns that need to be filed with the GST Network (GSTN). The system allows you to quickly generate these returns by automatically compiling all necessary information from your transactions. This ensures that your returns are accurate and compliant with GST requirements, and can be filed promptly without the need for extensive manual input.",
            id: 3,
            activeIndex: 0,
        },
        {
            para: (
                <span style={{ width: "90%" }}>
                    What is the benefit of integrating QueueBuster with GST Suvidha Providers (GSP)?
                </span>
            ),
            des: "Integrating QueueBuster with GST Suvidha Providers (GSP) offers the significant benefit of seamless report submission. This integration ensures that your GST reports are submitted accurately and on time, reducing the administrative burden on your business. By automating the submission process, QueueBuster helps maintain compliance with GST regulations, allowing you to focus on other critical aspects of your business operations.",
            id: 4,
            activeIndex: 0,
        },
        {
            para: (
                <span style={{ width: "90%" }}>
                    How does QueueBuster reduce manual errors in tax calculation?
                </span>
            ),
            des: "QueueBuster ensures accurate tax calculations by automating the process based on the latest GST rates and rules. Once you set GST rates as per the slab while creating your catalog, the system automatically applies the correct GST during billing. This eliminates manual input errors, enhances accuracy, and ensures compliance with GST regulations effortlessly.",
            id: 5,
            activeIndex: 0,
        },

        {
            para: (
                <span style={{ width: "90%" }}>
                   What is the payment facility provided by QueueBuster for GST?
                </span>
            ),
            des: "This feature simplifies the payment process, reducing the risk of penalties and compliance issues. By automating the epayment process, QueueBuster ensures that your business remains compliant with GST regulations, thereby facilitating smooth and efficient operations.",
            id: 6,
            activeIndex: 0,
        },
        {
            para: (
                <span style={{ width: "90%" }}>
                    How does QueueBuster generate precise reports for ITC and GST amounts?
                </span>
            ),
            des: "QueueBuster generates accurate reports for Input Tax Credit (ITC) and GST amounts by compiling accurate data from all transactions. These reports provide clear and detailed information, helping you track ITC claims and GST liabilities efficiently. This precise reporting ensures that your tax filing is accurate and compliant with GST regulations, optimizing your tax benefits and minimizing compliance risks.",
            id: 7,
            activeIndex: 0,
        },
        {
            para: (
                <span style={{ width: "90%" }}>
                    How does QueueBuster ensure GST-compliant invoices and receipts?
                </span>
            ),
            des: "QB GSP integrated POS ensures that all invoices and receipts generated by your business are GST-compliant by automatically including all necessary details and formatting them as per GST regulations. This compliance is crucial for avoiding issues during audits and ensuring smooth operations. The system's automation ensures that every invoice and receipt meets the required standards, thereby enhancing overall compliance and operational efficiency.",
            id: 8,
            activeIndex: 0,
        },
        {
            para: (
                <span style={{ width: "90%" }}>
                    Can QueueBuster handle GST filing for multiple business locations?
                </span>
            ),
            des: "This solution can handle GST filing for multiple business locations by consolidating data from all locations into a single, unified system. This capability ensures that GST returns are accurately compiled and filed for each location while maintaining compliance with GST regulations. The system's ability to manage multiple locations simplifies the filing process and ensures that all locations are covered under the same compliance framework.",
            id: 9,
            activeIndex: 0,
        },
        {
            para: (
                <span style={{ width: "90%" }}>
                    How does QueueBuster assist in GST reconciliation?
                </span>
            ),
            des: "GST reconciliation is easily processed by providing detailed reports and accurate transaction data, which are crucial for matching with GST returns filed. The system automates the reconciliation process by comparing the recorded transactions with the returns filed, identifying discrepancies, and ensuring that all data is aligned. This automated reconciliation enhances accuracy, reduces the risk of errors, and ensures compliance with GST regulations, making the reconciliation process smooth and efficient.",
            id: 10,
            activeIndex: 0,
        },
    ];

    return (
        <>
            <div className={styles.verificationPopupOverride}>
                <VerificationPopup isOpen={demoModal} closeModal={() => setDemoModal(false)} formHeading={formHeading} />
            </div>
            <div className={styles.hero_section}>
                <div className={styles.text_container}>
                    <div className={styles.hardware_logo} style={{ width: "12rem" }}><Image src="/assets/GSP.webp" alt="GSP" fill /></div>
                    <h1 className={styles.page_heading}>
                        <span className={styles.small_black_text}>GST Bill Now Made Easy</span><br />
                        <span className={styles.black_text}>with</span><span className={styles.blue_text}> QueueBuster POS</span>
                    </h1>
                    <p className={styles.page_desc}>QueueBuster offers seamless integration with GST Suvidha Providers (GSP), ensuring that your business effortlessly stays compliant with GST regulations. Our billing software simplifies GST-related processes, reduces manual errors, and provides accurate tax calculations and reports.</p>

                    <div className={styles.btn_container}>
                        <BlackCustomButton text="Try It Free" style={{ padding: "0 2rem" }} onClick={() => (setDemoModal(true), setHeading("14 Days free trial"))} />
                        <TransparentCustomButton text="Contact Sales" style={{ padding: "0 2rem" }} onClick={() => (setDemoModal(true), setHeading("Contact Sales"))} />
                    </div>
                </div>
                <div className={styles.hero_img} style={{ height: "38rem" }}><Image src="/assets/software-partners/gsp/hero-img.webp" alt="GSP" fill /></div>
            </div>

            <div className={styles.marquee_section}>
                <div className={styles.section_heading}><h3>{commonMarqueTitle}</h3><div className={styles.heading_stroke} style={{ width: '22rem' }}><Image src='/assets/industry/restaurant/features_hl.svg' alt='stroke' fill /></div></div>
                <MarqueeComponentHomePage ClientsArr={ClientsArr1} />
            </div>

            <div className={styles.portable_devices}>
            <div className={styles.section_heading}><h3>Sell Securely with PayU and QueueBuster POS Billing Solution</h3><div className={styles.heading_stroke} style={{ width: '22rem' }}><Image src='/assets/industry/restaurant/features_hl.svg' alt='stroke' fill /></div></div>

                {/* <h2>Sell Securely with PayU and QueueBuster POS Billing Solution</h2> */}
                <HardwareFeatures features={gspFeatures} setDemoModal={setDemoModal} setHeading={setHeading} />
            </div>
            <AdvanceAnalyticsBanner setDemoModal={setDemoModal} setHeading={setHeading} />
            <div style={{ margin: "0 9.3rem" }}><ThreeStepForm /></div>

            <div style={{ margin: "5rem 6rem" }}><TestimonialSection testimonialData={testimonialData} videoTestimonial={videoTestimonial} /></div>
            <TrustFactor />

            <FrequentQuestions FaqTableData={GSPFAQ} heading={"Frequently Asked Questions for QB-GSP Integration"} />
            <div style={{ margin: "0 9.3rem" }}><PersonalisedDemoBanner setDemoModal={setDemoModal} setHeading={setHeading} /></div>
        </>
    )
}

export default DesktopGSP